import { AxiosResponse } from 'axios';

import { BasketItem } from '../../../models/basket-item';
import { SFCCBasket } from '../../../models/sfcc-basket';
import { SFCCProductItem } from '../../../models/sfcc-product-item';
import { makeCurrentBasketAction } from '../../../utilities/make-current-basket-action';
import { shopHttp } from '../../basket-api';

export const addProducts = async (
  items: BasketItem[],
  ensureBasketMethod: () => Promise<SFCCBasket>
): Promise<SFCCBasket> => {
  const products: SFCCProductItem[] = items.map(
    ({ sku, engravingMessage, quantity, services }) => ({
      product_id: sku,
      c_engravingMsg: engravingMessage,
      c_services: services,
      quantity: quantity ?? 1,
    })
  );

  return await makeCurrentBasketAction('/items', addProductsToBasket, ensureBasketMethod, products);
};

const addProductsToBasket = async (
  requestPath: string,
  body: SFCCProductItem[]
): Promise<SFCCBasket> => {
  const response = await shopHttp.post<SFCCProductItem[], AxiosResponse<SFCCBasket>>(
    requestPath,
    body
  );

  return response.data;
};
